/**
 * Fila de metadato reutilizable en el popover de eventos del calendario.
 */
export const EventPopoverMetaItem = ({ icon: Icon, label, children }) => (
    <div className="cal-event-popover__meta">
        <span className="cal-event-popover__meta-icon" aria-hidden="true">
            <Icon className="h-4 w-4" />
        </span>
        <div className="min-w-0">
            <p className="cal-event-popover__meta-label">{label}</p>
            <p className="cal-event-popover__meta-value">{children}</p>
        </div>
    </div>
);
